<div class="view-user">
  <div class="view-user__row">
    <span class="bold">{{ 'epd.functions.general.registered-on' | translate | capitalize }}</span>
    <div class="view-user__inputs">
      <mat-form-field appearance="outline" class="view-user__date" [subscriptSizing]="'dynamic'">
        <input matInput [matDatepicker]="picker" [value]="date()" (dateChange)="dateChange.emit($event.value)" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="view-user__time" [subscriptSizing]="'dynamic'">
        <input matInput type="time" [value]="time()" (focusout)="onTimeFocusOut($event)" />
      </mat-form-field>
    </div>
  </div>
  <div class="view-user__row">
    <span class="bold">{{ 'epd.functions.general.registered-by' | translate | capitalize }}</span>
    <mat-form-field appearance="outline" class="view-user__user" [subscriptSizing]="'dynamic'">
      <input matInput type="text" [value]="user()" (focusout)="onUserFocusOut($event)" />
    </mat-form-field>
  </div>
  <mat-divider class="view-user__divider"></mat-divider>
</div>
